import { useEffect, useState } from "react";
import "./Costumer.scss";
import APIModel from "../../APIModel";
import { useDispatch, useSelector } from "react-redux";
import { setToken } from "../../store/state/state";
import store from "../../store/store";
import { Link, redirect, useLoaderData, useSubmit } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export async function loader({ params }) {
  console.log(params.id);
  const token = store.getState().auth.token;
  const responce = await APIModel.getConsumer(token, params.id);
  if (responce.status === 403) {
    store.dispatch(setToken(""));
    return redirect("/login");
  }
  return { responce };
}
export async function action({ params, request }) {
  const formData = await request.formData();

  const token = store.getState().auth.token;
  console.log("test");
  const responce = await APIModel.updateCostumerDate(
    token,
    params.id,
    formData.get("date")
  );
  console.log(responce);
  if (responce.status === 403) {
    store.dispatch(setToken(""));
    return redirect("/login");
  }
  return redirect("/");
}
export default function Costumer() {
  const submit = useSubmit();
  const costumer = useLoaderData().responce;
  const [startDate, setStartDate] = useState(
    new Date(costumer.body.expressedIn)
  );

  console.log(costumer);

  return (
    <div className="costumer">
      <Link to="..">back</Link>
      <div className="costumer__about">
        <h2 className="costumer__title">
          First name: {costumer.body.firstName}
        </h2>
        <h2 className="costumer__title">Last name: {costumer.body.lastName}</h2>
      </div>
      <div className="costumer__date">
        <h3 className="costumer__created">
          createAt: {costumer.body.createAt}
        </h3>
        <h3 className="costumer__date">
          expressedIn:{""}
          <DatePicker
            className="costumer__datepicker"
            dateFormat="yyyy-MM-dd"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
          />
        </h3>
        <button
          className="costumer__update-time"
          onClick={() => {
            console.log("sumbit");
            submit({ date: startDate }, { method: "post" });
          }}
        >
          update-time
        </button>
      </div>
    </div>
  );
}
